import qs from 'qs'

export const queryEssaysPage = () => {
  const query = qs.stringify(
    {
      fields: ['title'],
      populate: {
        ...queryFragmentSingleTypeDefault
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `essays-page?${query}`
}
